// extracted by mini-css-extract-plugin
module.exports = {"Container":"style-module--Container--2z1Vo","Wrapper":"style-module--Wrapper--2ygg9","Image":"style-module--Image--2mI_o","Text":"style-module--Text--lRhLy"};